import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useProtectedAction } from '../hooks/useProtectedAction';

const FB_PROJ = 'migravip-e1afb';

// 🔧 LANCAMENTO: trava de feature. Vire para false quando os relatorios
// estiverem finalizados e com numeros confiaveis.
const EM_BREVE = true;
const MSG_EM_BREVE = 'Os relatórios estão sendo finalizados pra te entregar números confiáveis. Em breve no ar. 🚀';


const PRODUTOS_AVEC = [
  { nome: 'Plataforma — Até 2 Profissionais',               mrr: 89.90 },
  { nome: 'Plataforma — Até 5 Profissionais',               mrr: 143.90 },
  { nome: 'Plataforma — Até 10 Profissionais',              mrr: 251.90 },
  { nome: 'Plataforma — Até 20 Profissionais',              mrr: 347.90 },
  { nome: 'Plataforma — Até 30 Profissionais',              mrr: 479.90 },
  { nome: 'Plataforma — Até 40 Profissionais',              mrr: 549.90 },
  { nome: 'Plataforma — Até 50 Profissionais',              mrr: 659.90 },
  { nome: 'Plataforma — Profissionais Ilimitados',          mrr: 1127.90 },
  { nome: 'WhatsApp Profissional — Até 5',                  mrr: 149.00 },
  { nome: 'WhatsApp Profissional — Até 10',                 mrr: 350.00 },
  { nome: 'WhatsApp Profissional — Até 20',                 mrr: 500.00 },
  { nome: 'WhatsApp Profissional — Até 21+',                mrr: 1000.00 },
  { nome: 'Módulo Franquia',                                mrr: 191.90 },
  { nome: 'Módulo Nota Fiscal de Serviço',                  mrr: 114.90 },
  { nome: 'Módulo Nota Padrão Nacional',                    mrr: 9.90 },
  { nome: 'Módulo Nota Fiscal de Produto',                  mrr: 114.90 },
  { nome: 'PAY — Modelo TEF',                               mrr: 115.20 },
  { nome: 'White Label Manutenção',                         mrr: 500.00 },
  { nome: 'API / Avec Lake — Até 10 lojas',                 mrr: 114.90 },
  { nome: 'API / Avec Lake — 11 a 20 lojas',               mrr: 102.90 },
  { nome: 'API / Avec Lake — Acima de 20 lojas',            mrr: 90.90 },
  { nome: 'Suporte Premium',                                mrr: 59.90 },
  { nome: 'IA Completa (Confirmação + Agendamento + Marketing)', mrr: 650.00 },
];

const calcMRR = (nomeContrato, nomeComponente) => {
  const p1 = PRODUTOS_AVEC.find(x => x.nome === nomeContrato);
  const p2 = PRODUTOS_AVEC.find(x => x.nome === nomeComponente);
  return (p1?.mrr || 0) + (p2?.mrr || 0);
};

const fmt = (v) => `R$${v.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;

async function fsGet(path, token) {
  const r = await fetch(
    `https://firestore.googleapis.com/v1/projects/${FB_PROJ}/databases/(default)/documents/${path}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!r.ok) return null;
  return r.json();
}

async function fsList(path, token) {
  const r = await fetch(
    `https://firestore.googleapis.com/v1/projects/${FB_PROJ}/databases/(default)/documents/${path}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (!r.ok) return [];
  const data = await r.json();
  return data.documents || [];
}

// ─── Mini gráfico de barras SVG ───────────────────────────────────────────────
function BarChart({ dados }) {
  if (!dados.length) return null;
  const max    = Math.max(...dados.map(d => d.mrr), 1);
  const W      = 600;
  const H      = 160;
  const pad    = 40;
  const barW   = Math.min(40, (W - pad * 2) / dados.length - 8);
  const total  = W - pad * 2;
  const step   = total / dados.length;

  return (
    <svg viewBox={`0 0 ${W} ${H + 40}`} style={{ width: '100%', maxWidth: W }}>
      {/* Grid lines */}
      {[0, 0.25, 0.5, 0.75, 1].map(p => (
        <g key={p}>
          <line x1={pad} y1={H - p * H + 10} x2={W - pad} y2={H - p * H + 10}
            stroke="rgba(0,0,0,0.06)" strokeWidth="1" />
          <text x={pad - 6} y={H - p * H + 14} textAnchor="end"
            fill="#9898b8" fontSize="9" fontFamily="monospace">
            {p > 0 ? `${(max * p / 1000).toFixed(0)}k` : '0'}
          </text>
        </g>
      ))}
      {/* Barras */}
      {dados.map((d, i) => {
        const x = pad + i * step + step / 2 - barW / 2;
        const h = (d.mrr / max) * (H - 20);
        const y = H - h + 10;
        return (
          <g key={d.mes}>
            <rect x={x} y={y} width={barW} height={h} rx="4"
              fill="url(#barGrad)" opacity="0.9" />
            <text x={x + barW / 2} y={y - 5} textAnchor="middle"
              fill="#6c47ff" fontSize="9" fontFamily="monospace" fontWeight="700">
              {d.mrr >= 1000 ? `${(d.mrr/1000).toFixed(1)}k` : d.mrr.toFixed(0)}
            </text>
            <text x={x + barW / 2} y={H + 26} textAnchor="middle"
              fill="#9898b8" fontSize="9" fontFamily="monospace">
              {d.mes.slice(5)}
            </text>
          </g>
        );
      })}
      <defs>
        <linearGradient id="barGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#6c47ff" />
          <stop offset="100%" stopColor="#5535e0" stopOpacity="0.7" />
        </linearGradient>
      </defs>
    </svg>
  );
}

// ─── Página Relatórios ────────────────────────────────────────────────────────
export default function Relatorios() {
  const { user, contaUid }    = useAuth();
  const { protect, Modals, logado, temPlano } = useProtectedAction(true);
  const [clientes,  setClientes]  = useState([]);
  const [snapshots, setSnapshots] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [filtro,    setFiltro]    = useState('');
  const [aba,       setAba]       = useState('mrr'); // 'mrr' | 'carteira' | 'upsell'

  useEffect(() => {
    if (!user || !contaUid) return;
    (async () => {
      try {
        const token = await user.getIdToken();

        // Carrega base atual
        const doc = await fsGet(`users/${contaUid}/clientes/dados`, token);
        if (doc) {
          try { setClientes(JSON.parse(doc.fields?.data?.stringValue || '[]')); }
          catch {}
        }

        // Carrega snapshots históricos
        const snaps = await fsList(`users/${contaUid}/snapshots`, token);
        const parsed = snaps.map(s => ({
          mes:    s.fields?.mes?.stringValue    || '',
          mrr:    s.fields?.mrr?.doubleValue    || 0,
          total:  s.fields?.total?.integerValue || 0,
          ativos: s.fields?.ativos?.integerValue || 0,
        })).filter(s => s.mes).sort((a, b) => a.mes.localeCompare(b.mes));
        setSnapshots(parsed);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, [user, contaUid]);

  // ── Métricas gerais ──
  const ativos     = clientes.filter(c => c.statusContrato === 'Ativo');
  const mrrTotal   = ativos.reduce((s, c) => s + calcMRR(c.nomeContrato, c.nomeComponente), 0);
  const ticketMed  = ativos.length ? mrrTotal / ativos.length : 0;
  const cancelados = clientes.filter(c => c.statusContrato === 'Cancelado').length;

  // ── Variação MRR mês anterior ──
  const mrrAnterior = snapshots.length >= 2 ? snapshots[snapshots.length - 2].mrr : null;
  const varMRR      = mrrAnterior ? ((mrrTotal - mrrAnterior) / mrrAnterior * 100).toFixed(1) : null;

  // ── Breakdown por produto ──
  const breakdown = PRODUTOS_AVEC.filter(p => p.mrr > 0).map(p => {
    const count = ativos.filter(c => c.nomeContrato === p.nome || c.nomeComponente === p.nome).length;
    return { nome: p.nome, count, mrr: count * p.mrr };
  }).filter(p => p.count > 0).sort((a, b) => b.mrr - a.mrr);

  // ── Análise de carteira ──
  const semComponente    = ativos.filter(c => !c.nomeComponente);
  const semWhatsApp      = ativos.filter(c => !c.nomeContrato?.includes('WhatsApp') && !c.nomeComponente?.includes('WhatsApp'));
  const semIA            = ativos.filter(c => !c.nomeContrato?.includes('IA') && !c.nomeComponente?.includes('IA'));
  const semModFranquia   = ativos.filter(c => !c.nomeContrato?.includes('Franquia') && !c.nomeComponente?.includes('Franquia'));
  const expirando        = clientes.filter(c => {
    if (!c.expiracaoContrato) return false;
    const dias = (new Date(c.expiracaoContrato) - new Date()) / 86400000;
    return dias >= 0 && dias <= 60;
  });

  // ── Filtro clientes ──
  const clientesFiltrados = ativos.filter(c =>
    !filtro || c.nomeContrato === filtro || c.nomeComponente === filtro
  );

  const _cardGate = { background: '#fff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '14px', padding: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', maxWidth: '420px', margin: '60px auto', textAlign: 'center' };
  const _gateBtn = { background: 'linear-gradient(135deg, #6c47ff, #5535e0)', color: '#fff', border: 'none', borderRadius: '10px', padding: '11px 28px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' };
  if (EM_BREVE) return (
    <div style={{ maxWidth: '960px', margin: '0 auto' }}>
      <div style={_cardGate}>
        <div style={{ fontSize: '40px', marginBottom: '14px' }}>🔧</div>
        <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: '20px', fontWeight: '800', marginBottom: '10px' }}>Em breve</h2>
        <p style={{ color: '#52526e', fontSize: '14px', lineHeight: 1.5 }}>{MSG_EM_BREVE}</p>
      </div>
    </div>
  );

  if (!logado) return (
    <div style={{ maxWidth: '960px', margin: '0 auto' }}>
      {Modals}
      <div style={_cardGate}>
        <div style={{ fontSize: '34px', marginBottom: '12px' }}>🔒</div>
        <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: '18px', fontWeight: '800', marginBottom: '8px' }}>Entre para ver os relatórios</h2>
        <button onClick={protect(() => {})} style={_gateBtn}>Entrar</button>
      </div>
    </div>
  );
  if (!temPlano) return (
    <div style={{ maxWidth: '960px', margin: '0 auto' }}>
      {Modals}
      <div style={_cardGate}>
        <div style={{ fontSize: '34px', marginBottom: '12px' }}>🔒</div>
        <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: '18px', fontWeight: '800', marginBottom: '8px' }}>Assine para ver os relatórios</h2>
        <p style={{ color: '#52526e', fontSize: '13px', marginBottom: '20px' }}>Os relatórios fazem parte do plano. Assine para acompanhar a evolução da sua carteira.</p>
        <button onClick={protect(() => {})} style={_gateBtn}>Ver planos</button>
      </div>
    </div>
  );

  if (loading) return (
    <div style={{ textAlign: 'center', padding: '80px', color: '#9898b8' }}>
      Carregando relatórios...
    </div>
  );

  if (clientes.length === 0) return (
    <div style={{ maxWidth: '960px', margin: '0 auto', textAlign: 'center', padding: '80px 20px' }}>
      <div style={{ fontSize: '40px', marginBottom: '12px' }}>📊</div>
      <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '700', fontSize: '18px', marginBottom: '8px' }}>
        Nenhum dado disponível
      </div>
      <div style={{ color: '#9898b8', fontSize: '13px' }}>
        Cadastre clientes na aba Clientes para ver os relatórios.
      </div>
    </div>
  );

  return (
    <div style={{ maxWidth: '960px', margin: '0 auto' }}>

      {/* Header */}
      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ fontFamily: 'Syne, sans-serif', fontSize: '26px',
          fontWeight: '800', letterSpacing: '-0.5px', marginBottom: '6px' }}>
          Relatórios
        </h1>
        <p style={{ color: '#52526e', fontSize: '13px' }}>
          Análise de MRR, carteira e oportunidades de upsell.
        </p>
      </div>

      {/* KPIs */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '12px', marginBottom: '28px' }}>
        {[
          { label: 'MRR Atual',     value: fmt(mrrTotal),  color: '#059669',
            sub: varMRR ? `${varMRR > 0 ? '+' : ''}${varMRR}% vs mês ant.` : null },
          { label: 'Clientes Ativos', value: ativos.length },
          { label: 'Ticket Médio',  value: fmt(ticketMed) },
          { label: 'Cancelados',    value: cancelados, color: cancelados > 0 ? '#dc2626' : '#0a0a18' },
        ].map(m => (
          <div key={m.label} style={{ background: '#fff', border: '1px solid rgba(0,0,0,0.08)',
            borderRadius: '12px', padding: '16px 18px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
            <div style={{ fontSize: '10px', color: '#9898b8', fontFamily: 'monospace',
              textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px' }}>{m.label}</div>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '20px', fontWeight: '800',
              color: m.color || '#0a0a18' }}>{m.value}</div>
            {m.sub && (
              <div style={{ fontSize: '10px', marginTop: '4px', fontFamily: 'monospace',
                color: parseFloat(varMRR) >= 0 ? '#059669' : '#dc2626' }}>{m.sub}</div>
            )}
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '4px', marginBottom: '24px',
        background: '#f0f0f8', borderRadius: '10px', padding: '3px', width: 'fit-content' }}>
        {[
          { id: 'mrr',      label: '📈 MRR Histórico' },
          { id: 'carteira', label: '📦 Por Produto' },
          { id: 'upsell',   label: '🎯 Oportunidades' },
        ].map(t => (
          <button key={t.id} onClick={() => setAba(t.id)}
            style={{ padding: '8px 16px', borderRadius: '8px', border: 'none',
              fontSize: '13px', fontWeight: '600', cursor: 'pointer',
              background: aba === t.id ? '#fff' : 'transparent',
              color: aba === t.id ? '#6c47ff' : '#9898b8',
              boxShadow: aba === t.id ? '0 1px 4px rgba(0,0,0,0.1)' : 'none' }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ── Aba MRR Histórico ── */}
      {aba === 'mrr' && (
        <div>
          <div style={card}>
            <div style={cardTitle}>Evolução do MRR</div>
            {snapshots.length < 2 ? (
              <div style={{ color: '#9898b8', fontSize: '13px', padding: '20px 0' }}>
                📅 O gráfico aparece após o segundo mês de dados. Cada vez que você atualizar a base, um snapshot é salvo automaticamente.
              </div>
            ) : (
              <BarChart dados={snapshots} />
            )}
          </div>

          {snapshots.length > 0 && (
            <div style={card}>
              <div style={cardTitle}>Histórico de Snapshots</div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr>
                    {['Mês', 'MRR', 'Total', 'Ativos', 'Var. MRR'].map(h => (
                      <th key={h} style={{ textAlign: 'left', padding: '8px 12px',
                        fontSize: '10px', color: '#9898b8', fontFamily: 'monospace',
                        textTransform: 'uppercase', letterSpacing: '0.06em',
                        borderBottom: '1px solid rgba(0,0,0,0.06)' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[...snapshots].reverse().map((s, i, arr) => {
                    const prev = arr[i + 1];
                    const var_ = prev ? ((s.mrr - prev.mrr) / prev.mrr * 100).toFixed(1) : null;
                    return (
                      <tr key={s.mes}>
                        <td style={td}>{s.mes}</td>
                        <td style={{ ...td, fontWeight: '700', color: '#059669' }}>{fmt(s.mrr)}</td>
                        <td style={td}>{s.total}</td>
                        <td style={td}>{s.ativos}</td>
                        <td style={td}>
                          {var_ !== null ? (
                            <span style={{ color: parseFloat(var_) >= 0 ? '#059669' : '#dc2626',
                              fontFamily: 'monospace', fontWeight: '600' }}>
                              {var_ > 0 ? '+' : ''}{var_}%
                            </span>
                          ) : '—'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* ── Aba Por Produto ── */}
      {aba === 'carteira' && (
        <div>
          <div style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <div style={cardTitle}>MRR por Produto</div>
              <select value={filtro} onChange={e => setFiltro(e.target.value)}
                style={{ padding: '6px 10px', borderRadius: '8px', border: '1.5px solid rgba(0,0,0,0.1)',
                  fontSize: '12px', background: '#f8f8fc', color: '#0a0a18', cursor: 'pointer' }}>
                <option value="">Todos os produtos</option>
                {PRODUTOS_AVEC.filter(p => p.mrr > 0).map(p => (
                  <option key={p.nome} value={p.nome}>{p.nome}</option>
                ))}
              </select>
            </div>

            {breakdown.map(p => {
              const pct = mrrTotal > 0 ? (p.mrr / mrrTotal * 100) : 0;
              return (
                <div key={p.nome} style={{ marginBottom: '14px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', marginBottom: '5px' }}>
                    <span style={{ fontSize: '12px', color: '#0a0a18', fontWeight: '500' }}>{p.nome}</span>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                      <span style={{ fontSize: '11px', color: '#9898b8', fontFamily: 'monospace' }}>
                        {p.count} cliente{p.count > 1 ? 's' : ''}
                      </span>
                      <span style={{ fontSize: '12px', fontWeight: '700', color: '#059669',
                        fontFamily: 'monospace', minWidth: '80px', textAlign: 'right' }}>
                        {fmt(p.mrr)}
                      </span>
                    </div>
                  </div>
                  <div style={{ height: '6px', background: 'rgba(0,0,0,0.06)', borderRadius: '3px' }}>
                    <div style={{ height: '100%', width: `${pct}%`, borderRadius: '3px',
                      background: 'linear-gradient(90deg, #6c47ff, #5535e0)' }} />
                  </div>
                </div>
              );
            })}
          </div>

          {/* Lista de clientes filtrada */}
          {filtro && (
            <div style={card}>
              <div style={cardTitle}>
                Clientes com "{filtro}" ({clientesFiltrados.length})
              </div>
              {clientesFiltrados.map(c => (
                <div key={c.id} style={{ padding: '10px 0',
                  borderBottom: '1px solid rgba(0,0,0,0.05)',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '600' }}>{c.nome}</div>
                    <div style={{ fontSize: '11px', color: '#9898b8', fontFamily: 'monospace' }}>
                      ID: {c.clienteId || '—'} · {c.documento || '—'}
                    </div>
                  </div>
                  <div style={{ fontSize: '12px', fontWeight: '700', color: '#059669', fontFamily: 'monospace' }}>
                    {fmt(calcMRR(c.nomeContrato, c.nomeComponente))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* ── Aba Oportunidades ── */}
      {aba === 'upsell' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

          {expirando.length > 0 && (
            <div style={{ ...card, border: '1px solid rgba(217,119,6,0.3)', background: 'rgba(217,119,6,0.03)' }}>
              <div style={{ ...cardTitle, color: '#d97706' }}>
                ⚠️ Contratos expirando em 60 dias ({expirando.length})
              </div>
              {expirando.map(c => (
                <div key={c.id} style={{ padding: '8px 0', borderBottom: '1px solid rgba(0,0,0,0.05)',
                  display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: '13px' }}>{c.nome}</span>
                  <span style={{ fontSize: '11px', color: '#d97706', fontFamily: 'monospace' }}>
                    Exp: {c.expiracaoContrato}
                  </span>
                </div>
              ))}
            </div>
          )}

          {[
            { titulo: '💬 Sem WhatsApp Profissional', lista: semWhatsApp,
              desc: 'Clientes ativos sem WhatsApp Profissional — oportunidade de upsell.' },
            { titulo: '🤖 Sem IA Completa', lista: semIA,
              desc: 'Clientes que ainda não contrataram a IA Completa.' },
            { titulo: '🏪 Sem Módulo Franquia', lista: semModFranquia,
              desc: 'Clientes sem o Módulo Franquia ativo.' },
            { titulo: '➕ Sem Componente Adicional', lista: semComponente,
              desc: 'Clientes com apenas um produto — potencial de adicionar complemento.' },
          ].map(grupo => (
            <div key={grupo.titulo} style={card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                <div>
                  <div style={cardTitle}>{grupo.titulo}</div>
                  <div style={{ fontSize: '11px', color: '#9898b8', marginTop: '2px' }}>{grupo.desc}</div>
                </div>
                <span style={{ background: 'rgba(108,71,255,0.1)', color: '#6c47ff',
                  borderRadius: '20px', padding: '3px 12px', fontSize: '12px',
                  fontWeight: '700', flexShrink: 0, marginLeft: '12px' }}>
                  {grupo.lista.length}
                </span>
              </div>
              {grupo.lista.length === 0 ? (
                <div style={{ fontSize: '12px', color: '#9898b8', fontStyle: 'italic' }}>
                  Nenhum cliente nesta categoria.
                </div>
              ) : (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                  {grupo.lista.slice(0, 10).map(c => (
                    <span key={c.id} style={{ padding: '4px 10px', borderRadius: '7px',
                      fontSize: '11px', background: 'rgba(0,0,0,0.04)', color: '#52526e' }}>
                      {c.nome}
                    </span>
                  ))}
                  {grupo.lista.length > 10 && (
                    <span style={{ padding: '4px 10px', borderRadius: '7px', fontSize: '11px',
                      background: 'rgba(108,71,255,0.08)', color: '#6c47ff' }}>
                      +{grupo.lista.length - 10} mais
                    </span>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const card = { background: '#fff', border: '1px solid rgba(0,0,0,0.08)',
  borderRadius: '14px', padding: '20px 22px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  marginBottom: '16px' };
const cardTitle = { fontFamily: 'Syne, sans-serif', fontWeight: '700',
  fontSize: '14px', marginBottom: '16px', color: '#0a0a18' };
const td = { padding: '10px 12px', borderBottom: '1px solid rgba(0,0,0,0.05)',
  fontFamily: 'DM Sans, sans-serif', fontSize: '13px', color: '#0a0a18' };
